import { useState } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import FiltersSection from '../components/FiltersSection';
import {
  DailyBreakdownByPurchaseSurceChart,
  DailyAquiredPremiumUsersCharts,
} from '../components/PaymentCharts';
export interface ChartsProps {
  dates: Date[];
}

const DailyPaymentAnalysis = () => {
  const [dates, setDates] = useState<Date[]>([
    new Date(Date.now() - 30 * 24 * 3600 * 1000),
    new Date(),
  ]);

  return (
    <PageLayoutsContainer
      title={`Daily Payment Analysis`}
      withoutRightPadding={false}
    >
      <div className="space-y-6 ">
        <FiltersSection
          dates={dates}
          setDates={(dates) => {
            setDates(dates);
          }}
          autoSelectDatesDirection="horizontal"
        />

        <div className="grid grid-cols-2  gap-4">
          <DailyAquiredPremiumUsersCharts dates={dates} />

          <DailyBreakdownByPurchaseSurceChart dates={dates} />
        </div>
      </div>
    </PageLayoutsContainer>
  );
};

export default DailyPaymentAnalysis;
